<form *ngIf="set" class="flex flex-col gap-1" [formGroup]="form">
  <ng-container *ngFor="let assignment of orderedAssignments">
    <ng-container *ngIf="assignment.kind === 'PROPERTY'" [formGroup]="propertyValuesForm">
      <vs-property-input-form-field
        *ngIf="showHidden || !assignment.propertyAssignment.hidden"
        [property]="assignment.propertyAssignment.property!"
        [hidden]="assignment.propertyAssignment.hidden"
        [showHidden]="showHidden"
        [autoVinLookup]="true"
        [order]="assignment.order"
        [formControlName]="assignment.propertyAssignment.property!.valueKey"
        [required]="assignment.propertyAssignment.required"
        [extraData]="extraData"
      >
      </vs-property-input-form-field>
    </ng-container>

    <ng-container *ngIf="assignment.kind === 'DIMENSION'" [formGroup]="dimensionValuesForm">
      <vs-dimension-input-form-field
        *ngIf="assignment.dimensionAssignment.dimension && (showHidden || !assignment.dimensionAssignment.hidden)"
        [dimension]="assignment.dimensionAssignment.dimension"
        [hidden]="assignment.dimensionAssignment.hidden"
        [showHidden]="showHidden"
        [order]="assignment.order"
        [formControlName]="assignment.dimensionAssignment.dimensionId"
        [required]="assignment.dimensionAssignment.required"
      >
      </vs-dimension-input-form-field>
    </ng-container>
  </ng-container>
</form>
